import MeasurementsView from "components/MeasurementsView";
import HelpFloatingButtonV2 from "components/HelpFloatingButtonV2";

function ManageMeasurements() {
  return (
    <>
      <HelpFloatingButtonV2 helpScreen="loads" />
      <MeasurementsView />
    </>
  );
}

export default ManageMeasurements;
